import React, { useState, useEffect } from 'react';
import Modal from "../clientes/ClienteModal";
import moment from 'moment';
import Swal from 'sweetalert';

const HistorialAuditoria = ({ idRegistroDeFlete }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [historial, setHistorial] = useState([]);
    const [loading, setLoading] = useState(false);
    const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);

    useEffect(() => {
        if (isOpen && idRegistroDeFlete) {
            fetchHistorial();
        }
    }, [isOpen, idRegistroDeFlete]);

    const fetchHistorial = async () => {
        setLoading(true);
        try {
            const response = await fetch(`/api/registrosflete/items/${idRegistroDeFlete}/auditoria`);
            const data = await response.json();

            if (data.ok) {
                setHistorial(data.historial || []);
            } else {
                Swal('Error', 'No se pudo cargar el historial de auditoría.', 'error');
            }
        } catch (error) {
            console.error('Error al cargar historial:', error);
            Swal('Error', 'Ocurrió un error al cargar el historial.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const getTipoAccionIcon = (tipoAccion) => {
        switch (tipoAccion) {
            case 'ENLAZAR':
                return <i className="fas fa-link text-success" title="Enlazar"></i>;
            case 'DESENLAZAR':
                return <i className="fas fa-unlink text-danger" title="Desenlazar"></i>;
            case 'MODIFICAR':
                return <i className="fas fa-edit text-warning" title="Modificar"></i>;
            default:
                return <i className="fas fa-history text-info"></i>;
        }
    };

    const getTipoAccionBadge = (tipoAccion) => {
        const badges = {
            'ENLAZAR': 'badge badge-success',
            'DESENLAZAR': 'badge badge-danger',
            'MODIFICAR': 'badge badge-warning'
        };
        return badges[tipoAccion] || 'badge badge-secondary';
    };

    const verDetalle = (registro) => {
        setDetalleSeleccionado(registro);
    };

    const cerrarDetalle = () => {
        setDetalleSeleccionado(null);
    };

    const renderDetalleCompleto = () => {
        if (!detalleSeleccionado) return null;

        const movimientosAntes = detalleSeleccionado.MovimientosAntes 
            ? JSON.parse(detalleSeleccionado.MovimientosAntes) 
            : [];
        const movimientosDespues = detalleSeleccionado.MovimientosDespues 
            ? JSON.parse(detalleSeleccionado.MovimientosDespues) 
            : [];
        const detalles = detalleSeleccionado.Detalles 
            ? JSON.parse(detalleSeleccionado.Detalles) 
            : {};

        const getNumeroMovimiento = (id, detallesArray) => {
            if (!detallesArray) return `ID: ${id}`;
            const mov = detallesArray.find(m => m.id === id);
            return mov && mov.numero ? mov.numero : `ID: ${id}`;
        };

        return (
            <Modal isOpen={true} title="Detalle de Auditoría" onClose={cerrarDetalle}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header bg-primary text-white">
                                    <h6 className="mb-0">Información General</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">

                                            <p><strong>Usuario:</strong> {detalleSeleccionado.NombreUsuario}</p>
                                            <p><strong>Fecha:</strong> {detalleSeleccionado.FechaHora}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <p>
                                                <strong>Tipo de Acción:</strong>{' '}
                                                <span className={getTipoAccionBadge(detalleSeleccionado.TipoAccion)}>
                                                    {detalleSeleccionado.TipoAccion}
                                                </span>
                                            </p>
                                            <p><strong>Descripción:</strong> {detalleSeleccionado.Descripcion}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card mb-3">
                                <div className="card-header bg-info text-white">
                                    <h6 className="mb-0">Cambios Realizados</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h6 className="text-danger">
                                                <i className="fas fa-minus-circle"></i> Antes ({detalleSeleccionado.CantidadMovimientosAntes})
                                            </h6>
                                            {movimientosAntes.length === 0 ? (
                                                <p className="text-muted">Sin movimientos</p>
                                            ) : (
                                                <ul className="list-group list-group-flush">
                                                    {movimientosAntes.map(id => (
                                                        <li key={id} className="list-group-item py-1">
                                                            {getNumeroMovimiento(id, detalles.movimientosAntes)}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                        <div className="col-md-6">
                                            <h6 className="text-success">
                                                <i className="fas fa-plus-circle"></i> Después ({detalleSeleccionado.CantidadMovimientosDespues})
                                            </h6>
                                            {movimientosDespues.length === 0 ? (
                                                <p className="text-muted">Sin movimientos</p>
                                            ) : (
                                                <ul className="list-group list-group-flush">
                                                    {movimientosDespues.map(id => (
                                                        <li key={id} className="list-group-item py-1">
                                                            {getNumeroMovimiento(id, detalles.movimientosDespues)}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>

                                    {detalles.agregados && detalles.agregados.length > 0 && (
                                        <div className="mt-3">
                                            <div className="alert alert-success">
                                                <strong>
                                                    <i className="fas fa-plus"></i> Agregados:
                                                </strong>{' '}
                                                {detalles.agregados.map(item => 
                                                    typeof item === 'object' ? item.numero : `ID: ${item}`
                                                ).join(', ')}
                                            </div>
                                        </div>
                                    )}

                                    {detalles.eliminados && detalles.eliminados.length > 0 && (
                                        <div className="mt-3">
                                            <div className="alert alert-danger">
                                                <strong>
                                                    <i className="fas fa-minus"></i> Eliminados:
                                                </strong>{' '}
                                                {detalles.eliminados.map(item => 
                                                    typeof item === 'object' ? item.numero : `ID: ${item}`
                                                ).join(', ')}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="d-flex justify-content-end">
                                <button className="btn btn-secondary" onClick={cerrarDetalle}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    return (
        <>
            <button
                className="btn btn-sm btn-outline-info ml-2"
                onClick={() => setIsOpen(true)}
                disabled={!idRegistroDeFlete}
                title="Ver historial de cambios"
            >
                <i className="fas fa-history"></i> Historial
            </button>

            <Modal isOpen={isOpen} title={`Historial de Auditoría`} onClose={() => setIsOpen(false)}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Cargando...</span>
                                    </div>
                                    <p className="mt-2">Cargando historial...</p>
                                </div>
                            ) : historial.length === 0 ? (
                                <div className="alert alert-info">
                                    <i className="fas fa-info-circle"></i> No hay cambios registrados para este flete.
                                </div>
                            ) : (
                                <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                    <div className="timeline">
                                        {historial.map((item, index) => (
                                            <div key={item.IdAuditoria} className="timeline-item mb-3">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <div className="d-flex align-items-center">
                                                                <div className="mr-3" style={{ fontSize: '1.5rem' }}>
                                                                    {getTipoAccionIcon(item.TipoAccion)}
                                                                </div>
                                                                <div>
                                                                    <h6 className="mb-1">
                                                                        <span className={getTipoAccionBadge(item.TipoAccion)}>
                                                                            {item.TipoAccion}
                                                                        </span>
                                                                    </h6>
                                                                    <p className="mb-1">{item.Descripcion}</p>
                                                                    <small className="text-muted">
                                                                        <i className="fas fa-user"></i> {item.NombreUsuario}
                                                                        {' | '}
                                                                        <i className="fas fa-clock"></i> {item.FechaHora}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    onClick={() => verDetalle(item)}
                                                                    title="Ver detalles"
                                                                >
                                                                    <i className="fas fa-eye"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="mt-2">
                                                            <small>
                                                                <span className="badge badge-light">
                                                                    Antes: {item.CantidadMovimientosAntes}
                                                                </span>
                                                                {' → '}
                                                                <span className="badge badge-light">
                                                                    Después: {item.CantidadMovimientosDespues}
                                                                </span>
                                                                {item.Diferencia !== 0 && (
                                                                    <>
                                                                        {' '}
                                                                        <span className={item.Diferencia > 0 ? 'badge badge-success' : 'badge badge-danger'}>
                                                                            {item.Diferencia > 0 ? '+' : ''}{item.Diferencia}
                                                                        </span>
                                                                    </>
                                                                )}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className="mt-3 d-flex justify-content-between align-items-center">
                                <div>
                                    {historial.length > 0 && (
                                        <small className="text-muted">
                                            {historial.length} registro(s) en total
                                        </small>
                                    )}
                                </div>
                                <div>
                                    <button className="btn btn-secondary" onClick={() => setIsOpen(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {detalleSeleccionado && renderDetalleCompleto()}
        </>
    );
};

export default HistorialAuditoria;

